import RecoverStep from "../recover_step";
import {attachSelectableHandler} from "../../utils/recover_utils";

const TEMPLATE = 'export-type';

export default class SetExportType extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        if(data.recovery.virtualization){
            data.recovery.virtualization.isVHD = data.recovery.virtualization.location === 'vhd-export';
            data.recovery.virtualization.isVHDX = data.recovery.virtualization.location === 'vhdx-export';
            data.recovery.virtualization.format = data.recovery.virtualization.isVHD ? 'VHD' :
                (data.recovery.virtualization.isVHDX ? 'VHDX' : 'VMDK');
            fr.render('setExportType');
        } else{
            fr.goTo('setDevice');
        }
    }

    postRender(data, el, fr) {
        attachSelectableHandler(el, function(d) {
            data.recovery.virtualization.type = d.type;
        });
    }

    transitionNext(data, el, fr) {
        fr.render('setDevice');
    }

}
